module.exports = __webpack_public_path__ + "images/plan-2d-1-44f5960338bacbdcd8538d1415737f54.jpg";